import React, { useEffect } from 'react'
import { selectItineraryKeywords } from '../../store/ad/ad.selectors'
import { TAG_CLOSE_AD_BANNER } from '../analytics/analytics.tagids.constants'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import { withOnlyGE } from '../Device'
import encircledCross from '../genericComponents/assets/encircled_cross.svg'
import SVGIcon from '../svg/SVGIcon'
import useUIDisplay from '../ui/useUIDisplay'
import useEventCallback from '../utils/useEventCallback'
import AdLoader from './AdLoader'
import s from './FloatingDesktopAdBanner.less'

const FloatingDesktopAdBanner = withOnlyGE(({ adName, keywordsSelector }) => {
  const configureAndSendTag = useConfigureAndSendTag()
  const { isUIDisplayed, showUI, hideUI } = useUIDisplay(UI_ELEMENTS.AD_BANNER)

  const onClose = useEventCallback(() => {
    hideUI()
    configureAndSendTag({
      type: TAG_CLOSE_AD_BANNER
    })
  }, [hideUI])

  useEffect(() => {
    showUI()

    return () => hideUI()
  }, [])

  if (!isUIDisplayed) {
    return <div />
  }

  return (
    <div className={s.container}>
      <AdLoader adName={adName} keywordsSelector={keywordsSelector} className={s.content} />
      <div className={s.closeButton} onClick={onClose}>
        <SVGIcon url={encircledCross} />
      </div>
    </div>
  )
})

export const AdDesktopBannerItineraryResult = () => (
  <FloatingDesktopAdBanner adName="itinerary_results_banner_desktop" keywordsSelector={selectItineraryKeywords} />
)
